import { render, staticRenderFns } from "./chemLawHistory.vue?vue&type=template&id=38b45932"
import script from "./chemLawHistory.vue?vue&type=script&lang=js"
export * from "./chemLawHistory.vue?vue&type=script&lang=js"
import style0 from "./chemLawHistory.vue?vue&type=style&index=0&id=38b45932&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b45932')) {
      api.createRecord('38b45932', component.options)
    } else {
      api.reload('38b45932', component.options)
    }
    module.hot.accept("./chemLawHistory.vue?vue&type=template&id=38b45932", function () {
      api.rerender('38b45932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemLawHistory.vue"
export default component.exports